import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpParamObject } from '../../utility/http-utility/http-param-object.interface';
import { HttpUtilityService } from '../../utility/http-utility/http-utility.service';
import { CapInfo, CapInfoOptions } from '@edassist/api';
import { CapInfoSelections } from '../../models/cap-info/cap-info-selections.interface';
import { withCache } from '@ngneat/cashew';
import { constants } from '@edassist/common';

@Injectable({ providedIn: 'root' })
export class CapInfoService {
	private readonly relativeUrl = 'cap-info/';

	constructor(private readonly http: HttpClient) {}

	getCapInfo(
		participantId: number,
		capInfoOptions: CapInfoOptions
	): Observable<CapInfo> {
		const httpParamOptions: HttpParamObject =
			HttpUtilityService.toPlainHttpParams(capInfoOptions);

		return this.http.get<CapInfo>(
			`${this.relativeUrl}participants/${participantId}`,
			httpParamOptions
		);
	}

	getSelections(participantId: number): Observable<CapInfoSelections> {
		return this.http.get<CapInfoSelections>(
			`${this.relativeUrl}participants/${participantId}/selections`,
			{
				context: withCache({
					version: constants.LOCAL_STORAGE.API_CACHE.VERSION_V1,
					key: `getSelections-${participantId}`
				})
			}
		);
	}

	saveSelections(
		participantId: number,
		capInfoSelections: CapInfoSelections
	): Observable<void> {
		return this.http.post<void>(
			`${this.relativeUrl}participants/${participantId}/selections`,
			capInfoSelections
		);
	}
}
